export default __webpack_public_path__ + "static/media/svg-1.7595513c.svg";